/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 10:09:47
 * @name: 工单管理-填写售后服务单
 * @Description: 工单管理-填写售后服务单
 * @FilePath: \project\src\module\issue\validator\addServiceIssue.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'agency_name',
    description: '经销商',
    required: true,
    required_message: '请填写经销商名称',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写经销商名称';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'mobile',
    description: '手机号',
    required: true,
    required_message: '请填写手机号',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写手机号';
      } else if (!(e.length === 11 && /^\d+$/.test(e))) {
        return '手机号格式错误';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'address',
    description: '地址',
    required: true,
    required_message: '请选择并填写地址',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请选择并填写地址';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'service_date_time',
    description: '服务日期',
    required: true,
    required_message: '请选择服务日期',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请选择服务日期';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'basic_remark',
    description: '基本信息备注',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'piano_brand',
    description: '钢琴品牌',
    required: true,
    required_message: '请填写钢琴品牌',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写钢琴品牌';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'piano_type',
    description: '钢琴型号',
    required: true,
    required_message: '请填写钢琴型号',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写钢琴型号';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'piano_number',
    description: '琴号',
    required: true,
    required_message: '请填写琴号',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写琴号';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'situation_des',
    description: '状况描述',
    required: true,
    required_message: '请填写状况描述',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写状况描述';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'item_service',
    description: '项目服务',
    required: true,
    required_message: '请填写项目服务',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写项目服务';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'tuner',
    description: '调律师',
    required: true,
    required_message: '请填写调律师',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请填写调律师';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
]